import slidebars from "exports-loader?slidebars!../../../libs/slidebars/dist/slidebars.js"
export default slidebars



// WEBPACK FOOTER //
// ./public/assets/js/src/vendor/slidebars.js